import { render, staticRenderFns } from "./AscHelpAndAboutTemplate.vue?vue&type=template&id=bc8bb7c8&"
import script from "./AscHelpAndAboutTemplate.vue?vue&type=script&lang=js&"
export * from "./AscHelpAndAboutTemplate.vue?vue&type=script&lang=js&"
import style0 from "./AscHelpAndAboutTemplate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports